import { BatchInput } from 'src/components/batch-input';

export default BatchInput;
